import { render } from "./SendReset.vue?vue&type=template&id=48c73f4b&ts=true"
import script from "./SendReset.vue?vue&type=script&lang=ts"
export * from "./SendReset.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__